/**
 * pdp video 播放
 */
const PlayPdpIcon = ({ width = 33, height = 33, bg = '#fff', color = '#000' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="32" height="32" rx="16" fill={bg} />
      <path
        d="M22.5327 16.391C22.6081 16.4441 22.6081 16.5559 22.5327 16.6091L13.4311 23.0188C13.3428 23.081 13.221 23.0178 13.221 22.9097L13.221 10.0904C13.221 9.98231 13.3428 9.91913 13.4311 9.98134L22.5327 16.391Z"
        fill={color}
      />
    </svg>
  )
}

export default PlayPdpIcon
